// extracted by mini-css-extract-plugin
export default {"messageFormHeading":"MessageForm_messageFormHeading__zRBrz","messageFormClickableText":"MessageForm_messageFormClickableText__XUzFs","formGroup":"MessageForm_formGroup__4tOOA"};